<template>
  <header class="yield-center-header">
    <h2>区域作物产量预判数据分析</h2>
    <div>历史数据驱动 | 生长条件修正 | 经营策略辅助</div>
  </header>
</template>

<style lang="less" scoped>
.yield-center-header {
  height: 100px;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-bottom: 2px solid rgba(39, 255, 232, 0.36);
  position: relative;
}

.yield-center-header::after {
  content: "";
  position: absolute;
  left: 390px;
  right: 0;
  bottom: -6px;
  height: 6px;
  background: linear-gradient(90deg, rgba(37, 255, 232, 0.7), transparent 40%, rgba(37, 255, 232, 0.75));
}

h2 {
  margin: 0;
  color: #ffffff;
  font-size: 50px;
  font-weight: 700;
  line-height: 68px;
  letter-spacing: 2px;
  text-shadow:
    0 0 8px rgba(255, 255, 255, 0.38),
    0 0 16px rgba(45, 255, 232, 0.42);
}

div {
  padding-top: 18px;
  color: #ffffff;
  font-size: 28px;
  font-weight: 700;
  line-height: 42px;
  text-align: right;
}
</style>
